// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Unteraufgabe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteUnteraufgabe(): (
  aufgabeId: string,
  unteraufgabeId: string
) => Promise<Unteraufgabe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, unteraufgabeId) =>
      (await getAPI()).unteraufgaben.deleteUnteraufgabe({
        aufgabeId,
        unteraufgabeId,
      }),
    [getAPI]
  );
}
